import { memo } from "react";
import { ConditionName, zIndex } from "interfaces";
import { conditions } from "helpers";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const PortraitPoll = dynamic(() => import("../../player-components/poll/portraitPoll/portraitPoll"));
const FullRate = dynamic(() => import("../../player-components/fullrate/fullrate"));
const AgeClassification = dynamic(() => import("../../player-components/ageClassification/ageClassification"));
const Lock = dynamic(() => import("../../player-components/lockUnlock/lock"));
const Unlock = dynamic(() => import("../../player-components/lockUnlock/unlock"));

const PortraitHeader = () => {
    useAppSelector(({ controller: { lock, activeElements } }) => ({ lock, activeElements }), shallowEqual);

    return (
        <>
            {!conditions(ConditionName.isFirstPlay) && (
                <div style={{ zIndex: zIndex.portraitHeader }} className={`pl-flex pl-items-center pl-justify-end pl-gap-5 pl-mt-3 pl-ml-3`}>
                    <>
                        {conditions(ConditionName.showAgeClassification) && <AgeClassification />}
                        <div
                            className={`animate__animated animate__faster ${
                                conditions(ConditionName.isActiveElements) ? "animate__fadeInDown" : "animate__fadeOutUp"
                            }`}
                        >
                            {conditions(ConditionName.isLock) ? <Lock /> : <Unlock />}
                        </div>
                        {conditions(ConditionName.showPoll) && <PortraitPoll />}
                        {conditions(ConditionName.showFullRate) && <FullRate />}
                    </>
                </div>
            )}
        </>
    );
};

export default memo(PortraitHeader);
